// extracted by mini-css-extract-plugin
module.exports = {"responsibleInvestmentHero":"ResponsibleInvestmentHero-module--responsible-investment-hero--1GXvj"};